
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/shopnow-guest",
      function () {
        return require("private-next-pages/explore/shopnow-guest.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/shopnow-guest"])
      });
    }
  